{
  "name": "rb-front",
  "version": "0.0.1",
  "buildNumber": "60",
  "buildDate": "2025-10-22T08:22:36",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "lint": "ng lint"
  },
  "private": true,
  "dependencies": {
    "@angular/common": "^19.2.0",
    "@angular/compiler": "^19.2.0",
    "@angular/core": "^19.2.0",
    "@angular/forms": "^19.2.0",
    "@angular/platform-browser": "^19.2.0",
    "@angular/platform-browser-dynamic": "^19.2.0",
    "@angular/router": "^19.2.0",
    "@ngrx/operators": "^19.1.0",
    "@ngrx/signals": "^19.1.0",
    "@ngx-translate/core": "^16.0.4",
    "@ngx-translate/http-loader": "^16.0.1",
    "@primeng/themes": "^19.1.2",
    "@stomp/rx-stomp": "^2.0.1",
    "date-fns": "^4.1.0",
    "jwt-decode": "^4.0.0",
    "lodash-es": "^4.17.21",
    "primeicons": "^7.0.0",
    "primeng": "^19.1.2",
    "rxjs": "~7.8.0",
    "tailwindcss-primeui": "^0.6.1",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.11",
    "@angular/cli": "^19.2.11",
    "@angular/compiler-cli": "^19.2.0",
    "@eslint/js": "^9.26.0",
    "@types/jasmine": "~5.1.0",
    "@types/lodash-es": "^4.17.12",
    "angular-eslint": "19.3.0",
    "autoprefixer": "^10.4.21",
    "eslint": "^9.23.0",
    "eslint-config-prettier": "^10.1.3",
    "eslint-plugin-prettier": "^5.4.0",
    "jasmine-core": "~5.6.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "postcss": "^8.5.3",
    "prettier": "^3.5.3",
    "tailwindcss": "^3.4.17",
    "typescript": "~5.7.2",
    "typescript-eslint": "8.27.0"
  }
}
